export default "__VITE_PUBLIC_ASSET__fb03c583__"